<template lang="pug">
	.tb(:class="{'error': error}")
		span.label(v-if="label")
			span(v-if="error") *
			| {{label}}
		label
			slot
			span.arrow-down

</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'
	.tb
		margin: 10px 0
		.label
			text-align: left
			font-size: body-font-size-xs
			color: sfc-pale-gray
		label
			width: 100%
			margin-bottom: 0px
			select
				width: 100%
				background: transparent
				font-size: body-font-size-md
				z-index: 20
				position: relative
				padding-right: 25px
				text-overflow: ellipsis
				color: sfc-gray-dark
				option
					color: body-font-color
		span.arrow-down
			right: 0
			top: 18px
			border-left: 5px solid transparent;
			border-right: 5px solid transparent;
			border-top: 6px solid #000
			z-index: 15
		&:hover
			span.arrow-down
				border-top: 7px solid #000
		&.error
			.label
				color: chart-red
			select
				border-bottom-color: chart-red

</style>
<script>
export default {
	props: {
		error:{
			default: false
		},
		value:{
			default: null
		},
		label:{
			default: null
		}
	},
	data() {
		return {
		}
	}
}
</script>
